class OGArticle {
    constructor(token) {
        this.published_time = undefined;
        this.modified_time = undefined;
        this.expiration_time = undefined;
        this.author = undefined;
        this.section = undefined;
        if (token == null)
            return;
        if (Array.isArray(token)) {
            this.published_time = token.find(o => o.Name === "article:published_time")?.Value;
            this.modified_time = token.find(o => o.Name === "article:modified_time")?.Value;
            this.expiration_time = token.find(o => o.Name === "article:expiration_time")?.Value;
            this.author = token.find(o => o.Name === "article:author")?.Value;
        }
        else {
            this.published_time = token.published_time;
            this.modified_time = token.modified_time;
            this.expiration_time = token.expiration_time;
            this.author = token.author;
        }
    }
}
class OGImage {
    constructor(token) {
        this.url = undefined;
        this.alt = undefined;
        if (token == null)
            return;
        if (Array.isArray(token)) {
            this.url = token.find(o => o.Name === "og:image" || o.Name === "og:image:url")?.Value;
            this.alt = token.find(o => o.Name === "og:image:alt")?.Value;
        }
        else {
            this.url = token.url;
            this.alt = token.alt;
        }
    }
}
class OGProfile {
    constructor(token) {
        this.first_name = undefined;
        this.last_name = undefined;
        this.username = undefined;
        this.gender = undefined;
        if (token == null)
            return;
        if (Array.isArray(token)) {
            this.first_name = token.find(o => o.Name === "profile:first_name")?.Value;
            this.last_name = token.find(o => o.Name === "profile:last_name")?.Value;
            this.username = token.find(o => o.Name === "profile:username")?.Value;
            this.gender = token.find(o => o.Name === "profile:gender")?.Value;
        }
        else {
            this.first_name = token.first_name;
            this.last_name = token.last_name;
            this.username = token.username;
            this.gender = token.gender;
        }
    }
}
class OGNode {
    constructor(token) {
        this.url = undefined;
        this.type = undefined;
        this.title = undefined;
        this.description = undefined;
        this.article = new OGArticle();
        this.image = new OGImage();
        this.profile = new OGProfile();
        if (token == null)
            return;
        if (Array.isArray(token)) {
            this.url = token.find(o => o.Name === "og:url")?.Value;
            this.type = token.find(o => o.Name === "og:type")?.Value;
            this.title = token.find(o => o.Name === "og:title")?.Value;
            this.description = token.find(o => o.Name === "og:description")?.Value;
            this.image = new OGImage(token);
            switch (this.type) {
                case "article":
                    this.article = new OGArticle(token);
                    break;
                case "profile":
                    this.profile = new OGProfile(token);
                    break;
            }
        }
        else {
            this.url = token.url;
            this.type = token.type;
            this.title = token.title;
            this.description = token.description;
            this.image = new OGImage(token.image);
            switch (token.type) {
                case "article":
                    this.article = new OGArticle(token.article);
                    break;
                case "profile":
                    this.profile = new OGProfile(token.profile);
                    break;
            }
        }
    }
}
export { OGNode };
